class AuthTimeout {
    constructor(timeoutMinutes = 30) {
        this.timeoutMinutes = timeoutMinutes;
        this.lastActivity = Date.now();
        this.checkInterval = 60000; // Check every minute
        this.init();
    }

    init() {
        // Update last activity on user interaction
        ['click', 'keypress', 'scroll', 'mousemove'].forEach(event => {
            document.addEventListener(event, () => this.updateLastActivity());
        });

        // Start checking for timeout
        this.startTimeoutCheck();
    }

    updateLastActivity() {
        this.lastActivity = Date.now();
    }

    startTimeoutCheck() {
        setInterval(() => this.checkTimeout(), this.checkInterval);
    }

    async checkTimeout() {
        const timeSinceLastActivity = (Date.now() - this.lastActivity) / 1000 / 60; // Convert to minutes
        if (timeSinceLastActivity >= this.timeoutMinutes) {
            window.location.reload();
        }
    }
}

// Initialize the auth timeout checker
document.addEventListener('DOMContentLoaded', () => {
    new AuthTimeout(30); // 30 minutes timeout
});
